import React, { Component } from 'react';
import { Loading } from 'bongga-react-simple-chatbot';
import { connect } from 'react-redux';
import { fetchModules } from '../../redux/modules/items';
import { fetchOptions } from '../../redux/modules/options';

class Option extends Component {
  componentDidMount() {
    const { getModules, getOptions, triggerNextStep } = this.props;
    const { steps, item, option, params, products } = this.props;

    const platform = steps['products-step-two'];
    const moduleItem = steps['modules-step-three'];

    if(item) {
      if(platform) {
        getModules(platform.value);
        triggerNextStep({ trigger: 'modules-step-three' });
      } else if(products && products.length > 0 && params.product) {
        const found = products.find(item => item.name.toLowerCase() === params.product);

        if(!!found) {
          getModules(found.id);
          triggerNextStep({ trigger: 'modules-step-three' });
        } else {
          triggerNextStep({ trigger: 'confirm' });
        }
      } else {
        triggerNextStep({ trigger: 'confirm' });
      }
    }

    if(moduleItem && option) {
      getOptions(moduleItem.value);
      triggerNextStep({ trigger: 'options-step-three' });
    }
  }

  render() {
    return <Loading />;
  }
}

const stateToProps = state => ({
  params: state.agent.params,
  products: state.products.data,
});

const actionsToProps = dispatch => ({
  getModules: id => dispatch(fetchModules(id)),
  getOptions: id => dispatch(fetchOptions(id)),
});

export default connect(stateToProps, actionsToProps)(Option);
